module.exports = __webpack_public_path__ + "img/photo-user-2.3d20841e.svg";